import { Spin, Divider } from 'antd';
import { useState } from 'react';
import { LEDGER_CANISTER_ID, SHIKU_CANISTER_ID } from '../../config/icConfig';
import { useDispatchStore, useStateStore } from '../../store';
import { createActor } from '../../utils/actor';
import { getAgent } from '../../utils/agent';
import { idlFactory as shikuIdl } from '../../services/candid/shiku.did';
import { idlFactory as ledgerIdl } from '../../services/candid/ledger.did';
import  './index.less'
import { useNavigate } from 'react-router-dom';
import { principalToAccountIdentifier } from '../../utils/principal';

const Login = () => {
  const dispatch = useDispatchStore()
  const state = useStateStore()
  const navigate = useNavigate()

  const { whitelist } = state.default

  const [logining, setLogining] = useState(false);
  const [loginStatus, setLoginStatus] = useState('')

  const handleLogin = async (type) => {
    setLogining(true);
    let agent = await getAgent(type, whitelist)
    const principal = (await agent.getPrincipal()).toString()
    const shikuActor = await createActor(SHIKU_CANISTER_ID, shikuIdl, agent)
    const ledgerActor = await createActor(LEDGER_CANISTER_ID, ledgerIdl, agent)
    const icpBalance = Number((await ledgerActor.account_balance_dfx({account: principalToAccountIdentifier(principal, 0)})).e8s) / 1e8
    dispatch({
      type: 'setAgentReducer',
      payload: {
        agentType: agent.type_symbol,
        agent: agent,
        principal,
        shikuActor,
        ledgerActor,
        icpBalance,
      },
    })
    setLogining(false)
    navigate("/")
  };


  return (
    <div className='login'>
      <div className="banner">
        <div className="text-area">
          <div className="title">Connect wallet</div>
          <div className="description">Connected with one of available wallet providers or create a new Wallet</div>
        </div>
      </div>
      <div className="option-cells">
        {/*Plug*/}
        <div className="option" onClick={()=>handleLogin('plug')}>
          <div className="img-container">
            <img src="https://yumi-frontend-assets.s3.ap-east-1.amazonaws.com/yumi/wallet/ic_plug.svg" alt="" />
          </div>
          <div className="info">
            <span className="title">Plug</span>
            <span className="desc"> 
              A wallet to store and manage NFTs, Tokens, and connect to dAPPs on the Internet Computer.
            </span>
          </div>
        </div>
        <Divider />
        {/*Stoic*/}
        <div className="option" onClick={()=>handleLogin('stoic')}>
          <div className="img-container">
            <img src="https://yumi-frontend-assets.s3.ap-east-1.amazonaws.com/yumi/wallet/ic_stoic.svg" alt="" />
          </div>
          <div className="info">
            <span className="title">Stoic</span>
            <span className="desc"> 
              Multi-purpose crypto wallet for the Internet Computer. 
            </span>
          </div>
        </div>
        {
          logining ? (
            <div className="login-loading">
              <Spin style={{ width: "100px", height: "100px" }} />
              {loginStatus}
            </div>
          ) : null
        }
      </div>
    </div>
  );
};

export default Login;
